export default __webpack_public_path__ + "static/media/English.801f79b1.png";